<template>
  <div class="reportAreaContentPart2 px-3" :class="divEditListRedBorder && 'redborder'" id="divEditList">
    <div v-if="termlyReportListInt.length < 1" class="empty-list_image">
      <strong>{{ lang('No Summative Report Found') }}...</strong>
      <img src="../../../assets/notfound.png" />
    </div>
    <div v-if="termlyReportListInt.length > 0" class="">
      <K2Row justify_content="flex-end" v-if="activeReport && activeReport.length">
        <K2Button size="mini" @onclick="bulkDownload">Download All</K2Button>
      </K2Row>
      <data-tables :data="termlyReportListInt" class="listTable">
        <el-table-column
          v-for="termlyReportListInfo in termlyReportList"
          :prop="termlyReportListInfo.prop"
          :label="termlyReportListInfo.label"
          :key="termlyReportListInfo.prop"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column :label="lang('Status')" width="200px">
          <template slot-scope="scope">
            <button
              v-if="!tourRunning"
              @click="handleAction(scope.row.TeRpStatus, scope.row.TeRpID, scope.row.TeRpStudentID)"
              :class="lang(scope.row.TeRpStatus) === lang('Published') ? 'actionButtonActive' : 'actionButtonPending'"
            >
              {{ lang(scope.row.TeRpStatus) }}
            </button>
            <button v-if="tourRunning" :class="scope.row.TeRpStatus === lang('Published') ? 'actionButtonActive' : 'actionButtonPending'">
              {{ lang(scope.row.TeRpStatus) }}
            </button>
          </template>
        </el-table-column>
      </data-tables>
    </div>
  </div>
</template>

<script>
import { lang } from '../../../locale'
import DataSource from '../../../data/datasource'
import K2Button from '../../../uiComponents/k2Button/k2Button'
import FileSaver from 'file-saver'
import JSZip from 'jszip'
import * as axios from 'axios'
import K2Row from '../../../uiComponents/k2Row/k2Row'
import { checkUrlStatus } from '@/helper/utily'

export default {
  name: 'TermlyModeList',
  components: { K2Row, K2Button },
  props: ['termlyReportListInt', 'tourRunning', 'action', 'updateStudentID', 'divEditListRedBorder', 'clear', 'dllStudentList', 'withdrawnStudentList'],
  data() {
    return {
      activeReport: null,
      termlyReportList: [
        { prop: 'StudentName', label: lang('Student Name') },
        { prop: 'Title', label: lang('Title') },
        { prop: 'TeRpCreatedOn_edited', label: lang('Date') },
        { prop: 'convertSubmitDate', label: lang('Submitted Date') },
      ],
    }
  },
  watch: {
    termlyReportListInt: function (value) {
      // watch it
      if (value) {
        this.checkActiveReport()
      }
    },
  },
  mounted() {
    this.checkActiveReport()
  },
  methods: {
    lang,
    checkActiveReport() {
      this.activeReport = this.termlyReportListInt.filter(d => d.TeRpStatus === 'Published')
    },
    handleAction(TeRpStatus, TeRpID, TeRpStudentID) {
      switch (lang(TeRpStatus)) {
        case lang('Reject'):
        case lang('Rejected'):
          this.$emit('action', 'Draft', TeRpID, TeRpStudentID)
          break
        case lang('Publish'):
        case lang('Published'):
          this.$emit('action', 'Active', TeRpID, TeRpStudentID)
          break
      }
      this.$emit('action', TeRpStatus, TeRpID, TeRpStudentID)
      this.$emit('updateStudentID', TeRpStudentID)
    },
    getDownloadFile(url) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url,
          responseType: 'arraybuffer',
        })
          .then(data => {
            resolve(data.data)
          })
          .catch(error => {
            reject(error.toString())
          })
      })
    },
    async bulkDownload() {
      this.$notify({
        title: lang('Downloading...'),
        dangerouslyUseHTMLString: true,
        message: `${lang('Download is in progress, Please don’t close the browser or click to other pages until the download completed')}`,
        iconClass: 'el-icon-loading',
        duration: 0,
      })

      let reportList = []
      if (this.activeReport && this.activeReport.length) {
        for (const d of this.activeReport) {
          if (d?.TeRpStatus === 'Published') {
            let pdfURL = `${process.env.VUE_APP_ROOT_API}External/STUDENTS/${d?.TeRpStudentID}/TERMLY_REPORTS/${d?.TeRpPbID}.pdf`

            if (pdfURL && (await checkUrlStatus(pdfURL))) {
              reportList.push({
                url: pdfURL,
                studentId: d.TeRpStudentID,
                studentName: d.StudentName,
                report: d.TeRpID,
              })
            }
          }
        }
      }

      const zip = new JSZip()
      const promises = []
      reportList.forEach((url, index) => {
        const promise = this.getDownloadFile(url.url).then(data => {
          const fileName = `${url.studentId}_${url.studentName}_${url.report}.pdf`
          zip.file(fileName, data, { binary: true })
        })
        promises.push(promise)
      })
      Promise.all(promises).then(() => {
        this.$notify.closeAll()
        zip.generateAsync({ type: 'blob' }).then(content => {
          FileSaver.saveAs(content, new Date().getTime())
        })
      })
    },
    async downloadTermlyReport(termlyReportID) {
      try {
        const response = await DataSource.shared.generateDownloadTermlyReportPDF(termlyReportID)
        if (response) {
          let byteChar = atob(response)
          let byteNo = new Array(byteChar.length)
          for (let i = 0; i < byteChar.length; i++) {
            byteNo[i] = byteChar.charCodeAt(i)
          }

          let byteArray = new Uint8Array(byteNo)
          let file = new Blob([byteArray], { type: 'application/pdf;base64' })
          return URL.createObjectURL(file)
          // window.open(URL.createObjectURL(file), '_blank', 'width=500, height=500');
        }
      } catch (e) {
        this.$notify.closeAll()
        this.$notify({
          title: lang('Error'),
          dangerouslyUseHTMLString: true,
          message: e,
        })
        this.results = e
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../termly';
</style>
